import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`;

export const ContainerIterations = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  ${({ bgColor }) =>
    css`
      background-color: ${bgColor};
    `};

  ${({ marginValue }) =>
    css`
      margin: ${marginValue};
    `};

  padding: 4px 12px;
  width: auto;
  max-width: 48%;

  ${({ radiusValue }) =>
    css`
      border-radius: ${radiusValue};
    `};
`;
